import { render, staticRenderFns } from "./StoreTitle.vue?vue&type=template&id=8b20494a&scoped=true"
import script from "./StoreTitle.vue?vue&type=script&lang=js"
export * from "./StoreTitle.vue?vue&type=script&lang=js"
import style0 from "./StoreTitle.vue?vue&type=style&index=0&id=8b20494a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b20494a",
  null
  
)

export default component.exports